import { IconButton, styled } from '@ethings/ui-toolkit';
import type { JSX } from 'react';
import ReactCountryFlag from 'react-country-flag';
import { useTranslation } from 'react-i18next';
import { Icon } from '../icons';
import { FlagButtonProps } from './types';

// Properly type the styled component with the necessary props
const StyledIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'sx',
})<Omit<FlagButtonProps, 'isoCode' | 'isFlagsMenuOpened' | 'disableDropdown'>>({});

const StyledIconButtonDisabled = styled(IconButton)({
  pointerEvents: 'none',
});

const FlagButton = (props: FlagButtonProps): JSX.Element => {
  const { isoCode, isFlagsMenuOpened, disableDropdown, ...iconButtonProps } = props;
  const { t } = useTranslation(['common']);

  if (disableDropdown) {
    return (
      <StyledIconButtonDisabled
        tabIndex={-1}
        className="PhoneInput-IconButton"
        disableRipple
        component="span"
      >
        {isoCode ? <ReactCountryFlag countryCode={isoCode} svg /> : <Icon icon="FlagIcon" />}
      </StyledIconButtonDisabled>
    );
  }

  return (
    <StyledIconButton
      {...iconButtonProps}
      aria-label={t('common:component.phone-input.labels.search')}
      id="PhoneInput-Select-Country"
      className="PhoneInput-Flag"
      data-testid="phone-input-select-country"
      aria-haspopup="listbox"
      aria-controls={isFlagsMenuOpened ? 'PhoneInput-Select-Country' : undefined}
      aria-expanded={isFlagsMenuOpened ? 'true' : 'false'}
    >
      {isoCode ? <ReactCountryFlag countryCode={isoCode} svg /> : <Icon icon="FlagIcon" />}
    </StyledIconButton>
  );
};

export default FlagButton;
